const $ = window.$;

export const appendScript = (src) => {
  if ($(`script[src="${src}"]`).length === 0) {
    $(`<script src="${src}" async></script>`).appendTo(document.body);
  }
};
